export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100">
              <i className="ri-mail-send-line text-2xl text-accent-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              午马影院欢迎广大影迷提供影片推荐与意见建议。如需影片投稿、广告合作或内容反馈，请通过以下方式与我们取得联系，我们将在 24 小时内回复您的讯息。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-accent-500"></i>
                <span>contact@wumacinema.com</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-foreground-300"></div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-wechat-line text-accent-500"></i>
                <span>午马影院官方公众号</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}